export enum ConsultState {
    Default = 'default',
    AudioUploaded = 'audioUploaded',
    ProcessingAudio = 'processingAudio',
    TranscriptionInProgress = 'transcriptionInProgress',
    TranscriptionComplete = 'transcriptionComplete',
    DiarizationInProgress = 'diarizationInProgress',
    DiarizationComplete = 'diarizationComplete',
    EntitiesInProgress = 'entitiesInProgress',
    EntitiesComplete = 'entitiesComplete',
    TemplateInProgress = 'templateInProgress',
    TemplateComplete = 'templateComplete',
    TemplateFailed = 'templateFailed',
    Retry = 'retry',
    NewTemplateInProgress = 'newTemplateInProgress',
    NewTemplateComplete = 'newTemplateComplete',
    PatientFound = 'patientFound',
    PatientNotFound = 'patientNotFound',
    PatientMatched = 'patientMatched',
    FormInProgress = 'formInProgress',
    FormComplete = 'formComplete',
    FormFailed = 'formFailed',
    FormPending = 'formPending',
}

export const consultStateDescription = {
    [ConsultState.Default]: 'Starting...',
    [ConsultState.AudioUploaded]: 'Generating notes...',
    [ConsultState.ProcessingAudio]: 'Generating notes...',
    [ConsultState.TranscriptionInProgress]: 'Transcription processing...',
    [ConsultState.TranscriptionComplete]: 'Transcription completed',
    [ConsultState.DiarizationInProgress]: 'Building consult...',
    [ConsultState.DiarizationComplete]: 'Compiling results...',
    [ConsultState.EntitiesInProgress]: 'Building consult...',
    [ConsultState.EntitiesComplete]: 'Compiling results...',
    [ConsultState.TemplateInProgress]: 'Building consult...',
    [ConsultState.TemplateComplete]: 'Template completed',
    [ConsultState.TemplateFailed]: 'Template generation failed',
    [ConsultState.Retry]: 'Waiting for retry...',
    [ConsultState.NewTemplateInProgress]: 'New template in progress',
    [ConsultState.NewTemplateComplete]: 'Verifying template',
    [ConsultState.PatientFound]: '',
    [ConsultState.PatientNotFound]: '',
    [ConsultState.PatientMatched]: '',
    [ConsultState.FormPending]: 'Preparing template...',
    [ConsultState.FormInProgress]: 'Generating template...',
    [ConsultState.FormComplete]: 'Verifying template',
    [ConsultState.FormFailed]: 'Form generation failed',
    /*[ConsultState.PatientFound]: 'TODO: Patient found',
    [ConsultState.PatientNotFound]: 'TODO: Patient not found',
    [ConsultState.PatientMatched]: 'TODO: Patient matched',*/
}

export function mapToConsultState(value: string): ConsultState | undefined {
    return Object.values(ConsultState).find((state) => value == state)
}

/**
 * The description for a consult state, or `undefined` for a state the app
 * doesn't know (a consult from the backend with an unmapped state).
 */
export function describeConsultState(
    state: ConsultState | undefined
): string | undefined {
    return state === undefined ? undefined : consultStateDescription[state]
}
